import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { Container, Grid, AppBar, Box } from '@mui/material';
import * as FitterHelper from '../library/FitterHelper';
import * as VersionChecker from '../library/VersionChecker';
import './RefreshVersion.css';

export default function RefreshVersion() {

    let navigate = useNavigate();

    useEffect((): void => {
        const getAsyncData = async () => {
            let needNewVersion = await VersionChecker.needNewVersion();
            if (needNewVersion){
                let versionInfo = await VersionChecker.getVersionInfo();
                let fitter = await FitterHelper.getFitter();
                let maxTries = fitter.iOS ? 4 : 4;
                let delay = fitter.iOS ? 1000 : 750;
                if (versionInfo.counter < maxTries){
                    versionInfo.counter += 1;
                    await VersionChecker.setVersionInfo(versionInfo);                   
                    setTimeout( () => {
                        (window as any).location.reload();
                    }, delay); 
                } else {
                    versionInfo.dateUpdated = new Date();
                    await VersionChecker.setVersionInfo(versionInfo);                    
                    //re-save the fitter info in the local db b/c we want to refresh the current fitter Id with the email address 
                    //(we're migrating from older versions that used the fitter's Cognito Id)
                    await FitterHelper.upsertFitter(fitter);
                    navigate(versionInfo.nextUrl);
                }
            }
        }
        getAsyncData();
    }, []);
    
    return (
        <>
            <div className='login-form'>
                <div className='clear-navbar'>
                    <Container component="main" maxWidth="lg">
                        <Box sx={{ flexGrow: 1 }} className='navbar'>
                            <AppBar position="static" className='appbar'>
                                <Grid container>
                                    <Grid item xs={12} sx={{marginTop: '100px'}}><h2><FormattedMessage id="general.latest.version" /></h2></Grid>
                                </Grid> 
                            </AppBar>
                        </Box>
                    </Container>
                </div>
            </div>
        </>
    )
}
